import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import 'aos/dist/aos.css';
import 'react-toastify/dist/ReactToastify.css';
import './style.css';
import { useEffect } from 'react';

import AOS from 'aos';
import { Route, BrowserRouter as Router, Routes } from 'react-router';
import { UserProvider, useUser } from './Context/useUser';
import ProtectedRoutes from './ProtectedRoutes';
import PublicRoutes from './PublicRoutes';
import PublicPageLayout from './Layouts/PublicPageLayout/PublicPageLayout';
import RecoverPasswordPage from './Pages/RecoverPasswordPage/RecoverPasswordPage';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ToastContainer } from 'react-toastify';

// The plugin must be registered before its defaults exist; charts opt in with datalabels.display.
Chart.register(ChartDataLabels);
Chart.defaults.plugins.datalabels.display = false;

const routeGenerator = routes => {
    const elementRoutes = routes.map(route => (
        <Route key={route.path} exact path={route.path} element={route.page}>
            {route.children ? routeGenerator(route.children) : null}
        </Route>
    ));
    // elementRoutes.push(<Route key={'/*'} exact path='/*' element={<div>Error page</div>} />);

    return elementRoutes;
};

const RouteDispatch = () => {
    const { user } = useUser();
    return (
        <Routes>
            {user ? routeGenerator(ProtectedRoutes(user)) : routeGenerator(PublicRoutes())}
        </Routes>
    );
};

function App() {
    useEffect(() => {
        AOS.init();
    }, []);

    return (
        <UserProvider>
            <Router>
                <Routes>
                    {/* Declared outside RouteDispatch so emailed reset/setup links
                        work whether or not a session exists. */}
                    <Route element={<PublicPageLayout />}>
                        <Route
                            path='/reset-password/:resetPasswordId'
                            element={<RecoverPasswordPage />}
                        />
                    </Route>
                    <Route exact path='/*' element={<RouteDispatch />} />
                </Routes>
            </Router>
            <div style={{ position: 'absolute' }}>
                <ToastContainer position='bottom-center' draggable={'mouse'} />
            </div>
        </UserProvider>
    );
}

export default App;
